import React, { useContext } from 'react';
import styles from './EnvironmentsString.module.css';

// Context
import FiltersContext from '../../context/FiltersContext';

// Interfaces
interface Props {
    profileIDs: number[]
}

const EnvironmentsString: React.FC<Props> = ({ profileIDs }) => {

    const { profiles } = useContext(FiltersContext);

    const parseProfiles = (profile_ids: number[]) =>
        profile_ids.map(id => profiles.find(p => p.id === id)?.name).join(', ');

    const parsedProfiles = parseProfiles(profileIDs);

    return (
        <>
            {profileIDs.length > 2 ? (
                <span className={styles.tag} title={parsedProfiles}>
                    {parseProfiles(profileIDs.slice(0, 2))} {`(+${profileIDs.length - 2})`}
                </span>
            ) : (
                <span className={styles.tag}>
                    {parsedProfiles}
                </span>
            )}
        </>
    );
};

export default EnvironmentsString;